module.exports = __webpack_public_path__ + "static/media/creativ10.064c8a75.jpg";